// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2rrbZ","alertIcon":"ConfirmModal_alertIcon__2IE4Y"};